<div class="container mx-auto px-4 py-8">
  <!-- Loading State -->
  <div *ngIf="loading" class="flex justify-center items-center min-h-[400px]">
    <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
    <span class="block sm:inline">{{ error }}</span>
  </div>

  <!-- Order Details -->
  <div *ngIf="!loading && !error && order" class="bg-white rounded-lg shadow-lg p-6">
    <h1 class="text-2xl font-bold mb-6 text-green-800">Sencha Steep in Transit</h1>
    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Order Info -->
      <div>
        <h2 class="text-lg font-semibold text-gray-700 mb-4">Order Information</h2>
        <div class="space-y-4">
          <div class="border-b pb-4">
            <p class="text-gray-600">Order ID: <span class="font-medium">{{ order.id }}</span></p>
            <p class="text-gray-600">Created: <span class="font-medium">{{ order.createdAt | date:'medium' }}</span></p>
            <p class="text-gray-600">Status: <span [class]="getStatusStyle(order.status)">{{ order.status }}</span></p>
          </div>
        </div>
      </div>

      <!-- Order Items -->
      <div>
        <h2 class="text-lg font-semibold text-gray-700 mb-4">Order Items</h2>
        <div class="bg-gray-50 rounded-lg p-4">
          <div *ngFor="let item of order.orderLineItems" class="flex items-center py-3 border-b last:border-0">
            <div class="w-16 h-16 mr-4 flex-shrink-0">

              <a [routerLink]="['/tea-item', item.slug]">
                <img [src]="item.imageUrl|imageModifier:{width:128} | async"
                     [alt]="item.name"
                     class="w-full h-full object-cover rounded-md dropshadow"
                     onerror="this.src='assets/placeholder-tea.png'">
              </a>
            </div>
            <div class="flex-grow">
              <span class="text-green-800 font-bold block">
                <a [routerLink]="['/tea-item', item.slug]">
                  {{ item.name }}
                </a>
              </span>
              <span class="text-sm text-gray-500">
                {{ item.productQuantity }} × {{ (item.unitPrice/100).toFixed(2) | currency:'AUD' }}
              </span>
            </div>
            <div class="text-right">
              <span class="font-medium block">{{ (item.unitPrice * item.productQuantity/100).toFixed(2) | currency:'AUD' }}</span>
              <span class="text-sm text-gray-500">Total</span>
            </div>
          </div>

          <!-- Discount Amount -->
          <div class="mt-4 pt-4 border-t" *ngIf="order.discountAmount > 0">
            <div class="flex justify-between items-center">
              <div>
                <span class="text-gray-600">Applied Discount:</span>
              </div>
              <span class="font-medium">{{ (order.discountAmount / 100).toFixed(2) | currency:'AUD' }}</span>
            </div>
          </div>
          
          <!-- Shipping Details -->
          <div class="mt-4 pt-4 border-t">
            <div class="flex justify-between items-center">
              <div>
                <span class="text-gray-600">Shipping Method:</span>
                <span class="ml-2 font-medium">{{ order.shippingDetail.serviceName }}</span>
              </div>
              <span class="font-medium">{{ order.shippingDetail.cost | currency:'AUD' }}</span>
            </div>
          </div>

          <!-- Total -->
          <div class="flex justify-between items-center mt-4 pt-4 border-t">
            <span class="text-lg font-semibold text-gray-800">Total</span>
            <span class="text-lg font-bold text-green-800">{{ (order.totalAmount / 100).toFixed(2) | currency:'AUD' }}</span>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-8 border-t border-gray-200">
    <tea-shop-fe-home-carousel></tea-shop-fe-home-carousel>
  </div>
</div>
